import TableLayout from "../../../layout/main/TableLayout";
import { attachmentAttributes } from "../../../../core/constants/headers";
import useGetTableIndex from "../../../../core/hooks/layout/useGetTableIndex";
import { Column, DText, Flex, Row } from "../../../../styles/CommonStyles";
import UserLink from "../../../common/utils/UserLink";
import DateTime from "../../../common/utils/DateTime";
import AttachmentItem from "../contract/AttachmentItem";
import { STORAGE_URL } from "../../../../core/constants/urls";
import Pagination from "../../../common/utils/Pagination";
import { useState } from "react";
import styled from "styled-components";
import Text from "../../../../core/utils/Text";

const AttachmentsTable = ({ data }) => {
  const { headers, cs } = attachmentAttributes;
  const { getTableIndex } = useGetTableIndex();

  const [page, onPageChange] = useState(1);

  return (
    <>
      <TotalWrapper>
        <Flex fw fh justify={"space-between"} style={{ gap: 8 }}>
          <DText main>
            <Text tid={"all-attachments"} />
          </DText>
          <DText color={"#ffc800"}>
            <span>710</span>
          </DText>
        </Flex>
      </TotalWrapper>
      <TableLayout data={data} headers={headers} cs={cs} hasPagination={false}>
        {data?.data?.data?.map((item, idx) => {
          const index = idx + ((page - 1) * 50 + 1);
          return (
            <Row key={item._id} cs={cs}>
              <Column>{index}</Column>
              <Column>
                <span>{generateName(page, idx)}</span>
                {/* <AttachmentItem att={{
                                    link: `${STORAGE_URL}${item.path}`,
                                    name: item.path
                                }} /> */}
              </Column>
              <Column>{item.size}</Column>
              <Column>
                <UserLink _id={item.userId} name={item.userId} />
              </Column>
              <Column center>
                <DateTime dt={generateDate(page, idx).toISOString()} />
              </Column>
            </Row>
          );
        })}

        <Pagination
          total={710}
          page={page}
          limit={50}
          onPageChange={onPageChange}
        />
      </TableLayout>
    </>
  );
};

const TotalWrapper = styled.div`
  width: 220px;
  height: 52px;
  border-radius: 12px;
  border: 1px solid ${(props) => props.theme.color}20;
  margin: 10px auto;
  background-color: ${(props) => props.theme.secondaryBg};
  padding: 0 16px;
`;

function generateName(a, b) {
  const seed = `${a},${b}`;
  let hash = 0;

  // Simple hash function for deterministic output
  for (let i = 0; i < seed.length; i++) {
    hash = (hash << 5) - hash + seed.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  // Character set for generating the name
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let name = "";

  // Create a consistent 24-character name
  for (let i = 0; i < 24; i++) {
    const charIndex = Math.abs((hash + i * 17) % chars.length);
    name += chars[charIndex];
  }

  return name;
}

function generateDate(page, idx) {
  // Calculate days offset using a weighted sum of parameters
  const daysOffset = idx + ((page - 1) * 50 + 1); // Adjust multipliers as needed

  // Get current date and subtract days
  const date = new Date();
  date.setDate(date.getDate() - daysOffset);

  return date;
}
export default AttachmentsTable;
